import produce from 'immer'
import { isEmpty } from 'lodash'
import { createActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.jobLabourRates, {
  transformGetItemsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.alwaysIncludeJobLabourRateIds =
        draft.alwaysIncludeJobLabourRateIds === false ? false : !isEmpty(draft.jobLabourRateIds)
    }),
  transformGetOptionsParams: (params = {}) =>
    produce(params, (draft) => {
      draft.alwaysIncludeJobLabourRateIds =
        draft.alwaysIncludeJobLabourRateIds === false ? false : !isEmpty(draft.jobLabourRateIds)
      draft.active = draft.active ?? 'Active'
    }),
})
